import React from "react";
import { Link } from "react-router-dom";

const LeadDataContainer2 = ({ text, data = [], columns }) => {
  return (
    <div>
      <div style={{ padding: "30px" }} className="text-center mb-4 light-bg-L">
        <p className="head-2 green-H">{text}</p>
        <div className="py-3 overflow-y-auto" style={{ maxHeight: "205px" }}>
          {data.length > 0 ? (
            <div className="grid grid-cols-2 gap-4 text-left">
              {columns.map((col, index) => (
                <div key={index} className="head-5 dark-H">
                  {col.label}
                </div>
              ))}

              {data.map((item, index) => (
                <React.Fragment key={index}>
                  {columns.map((col, colIndex) => (
                    <div key={colIndex} className="body-S green-H">
                      {col.key === "contact_name" ? (
                        <Link
                          to={`/contact/${item.contact_id_map}`}
                          className="underline"
                        >
                          {item[col.key] || ""}
                        </Link>
                      ) : col.key === "link_name" ? (
                        <>
                          <Link
                            to={`/property/${item.link_map_id}`}
                            className="underline block"
                          >
                            {(item.link_name &&
                              (item.link_type === "acquisition" ||
                                item.link_type === "property"))
                              ? item.link_name
                              : item.link_name || ""}
                          </Link>


                          {item.link_address_name && (
                            <div className="text-gray-600 text-xs mt-1">
                              {/* First line: Street */}
                              {item.link_address_name.street && (
                                <p>{item.link_address_name.street}</p>
                              )}

                              {/* Second line: City, State Zip */}
                              {(item.link_address_name.city ||
                                item.link_address_name.state ||
                                item.link_address_name.zip_code) && (
                                  <p>
                                    {item.link_address_name.city
                                      ? `${item.link_address_name.city}, `
                                      : ""}
                                    {item.link_address_name.state
                                      ? `${item.link_address_name.state} `
                                      : ""}
                                  </p>
                                )}
                            </div>
                          )}

                        </>
                      ) : (
                        item[col.key] || ""
                      )}
                    </div>
                  ))}
                </React.Fragment>
              ))}
            </div>
          ) : (
            <p className="head-5 dark-H p-0">N/A</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadDataContainer2;
